import { render } from "./QuizOpening.vue?vue&type=template&id=ee9f9b1e&scoped=true"
import script from "./QuizOpening.vue?vue&type=script&lang=js"
export * from "./QuizOpening.vue?vue&type=script&lang=js"

import "./QuizOpening.vue?vue&type=style&index=0&id=ee9f9b1e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9f9b1e"]])

export default __exports__